svg4everybody();

// Bootstrap
import "bootstrap/dist/js/bootstrap.bundle";
import './alertConditions';
import './financialSettings';
import './hamburgerMenu';

import "jquery-inview/jquery.inview.min";

import './transactions';

$(function () {
  $('[data-toggle="tooltip"]').tooltip();
});

$(() => {
  // 必要書類の提出のファイル選択処理
  $('input[type=file].js-review-document').on('change', e => {
    const target = $(e.target);
    const file = target.prop('files')[0];
    if (file) {
      target.siblings('.js-filename').text(file.name);
      target.siblings('.js-review-document-link').hide();
    } else {
      target.siblings('.js-filename').text('');
      target.siblings('.js-review-document-link').show();
    }
  });

  $('input[type=file].js-review-document-submit').on('change', e => {
    const target = $(e.target);
    if (e.target.files[0].size > 0) {
      target.parents('form').submit();
    }
  });
});
